function replaceVatTaxText(){
  $(".bss-b2b-translation-td-excluded_vat_text").each(function() {
    var text = $(this).text();
    text = text.replace("|", " ");
    $(this).text(text);
});
}
$( window ).on( "load", function() {
    $(".bss-b2b-translation-td-excluded_vat_text").each(function() {
    var text = $(this).text();
    text = text.replace("|", " ");
    $(this).text(text);
});
});
$(document).ready(function () {
  
  $('.bss-b2b-product-vat-price-has-vat').hide();
  $('.bss-b2b-product-vat-price-no-vat').show();
  $('.bss-b2b-cart-item-no-vat-price').show();
  $('.bss-b2b-cart-item-with-vat-price').hide();
  $('.bss-b2b-cart-no-vat-price').show();
  $('.bss-b2b-cart-with-vat-price').hide(); 
  $('.bss-b2b-cart-item-no-vat-price').show();
  $('.bss-b2b-cart-item-with-vat-price').hide(); 
  
  $('.QuickQuote').click(function(){
    $('.QuickQuote-sidebar').addClass('show');
    $('body').addClass('scroll-hidden');
  });
  $('#quote_open').click(function(){
    $('.QuickQuote-sidebar').addClass('show');
    $('body').addClass('scroll-hidden');
   }); 
  $('.overlay, .close-icon').click(function(){
    $('.QuickQuote-sidebar').removeClass('show');
    $('body').removeClass('scroll-hidden');
  });
   

  
});
// $(document).ready(function () {
  
//   $('.product-box').hide();
//   $('.collection').hide();
//   setTimeout(function () {
//     $(".spr-badge").each(function () {
//       let isDataRating = $(this).attr("data-rating");
//       if (isDataRating < 1) {
//         $(this).hide();
//       } else {
//         $(this).show();
//       }
//     });
//     $('.product-box').show();
//     $('.collection').show();
//     $('.price__regular').show();
    
//   }, 2000);
// });

// 29-03-23 UI change js Start
// $(document).ready(function(){
$('.header__inline-menu .list-menu .mega-menu').hover(function (e) {
  if (e.type == "mouseenter") {
    $(this).prop("open", true);
  } else if (e.type == "mouseleave") {
    $(this).removeAttr("open");
  }
});

$('#product-grid .card__inner a').matchHeight({
  byRow: true,
});
if ($('.boost-sd-layout .boost-sd-right .boost-sd__product-info .boost-sd__product-title').length > 0) {
  $('.boost-sd-layout .boost-sd-right .boost-sd__product-info .boost-sd__product-title').matchHeight({
    byRow: true,
  });
};

$('.box-services .wrapper .item .box .content p').matchHeight({
  byRow: true,
});
// });


// 29-03-23 UI change js End

// ---------------------------------------------------------------------------
Shopify.money_format = "£";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
$.getJSON('/cart.js', function (cart) {

  if (cart.item_count == 0) {
    $(".cart-footer-bottom").addClass('is-hide');
    $(".empty_cartdr_msg").removeClass('is-hide');
  } else {
    $(".cart-footer-bottom").removeClass('is-hide');
    $(".empty_cartdr_msg").addClass('is-hide');
  }


});
function updateCart() {
  $.ajax({
    url: '/cart?view=cw-slide-cart',
    dataType: 'HTML',
    method: "GET",
    success: function (htmlData) {
      let html_markup = $(htmlData);
      let to_replace = $(htmlData).find('.drawer-inner-top').html();


      $('.drawer-inner-top').html(to_replace);
      //$('.drawer').addClass('active');
      $('.drawer').removeClass('is-empty');
      let price = $('.js_cart_total').attr('data-cart-total');
     $('.js_cart_total').text(Shopify.formatMoney(price, $('body').attr('data-money-format')));
      
      $.getJSON('/cart.js', function (cart) {
        if (cart.item_count > 1) {

          $("#cart-item-counts").html(cart.item_count + ' Items');
        } else {

          $("#cart-item-counts").html(cart.item_count + ' Item');
        }
        if (cart.item_count == 0) {
          $(".cart-footer-bottom").addClass('is-hide');
          $(".empty_cartdr_msg").removeClass('is-hide');
        } else {
          $(".cart-footer-bottom").removeClass('is-hide');
          $(".empty_cartdr_msg").addClass('is-hide');
        }
        $(".js-icon-cart").html(cart.item_count );

      });
      // $('.js_qtyplus').unbind("click");
      // $('.js_qtyplus').on('click', function (e) {
      $(document).on('click', '.js_qtyplus', function (e) {
        e.preventDefault();
        let parent = $(e.target).parents('.js_par_qty').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) + 1;
        $(this).parent().find("input.quantity__input").val(updated_qty);
        let current_item = {};
        let key = $(parent).attr('data-key');
        current_item[key] = updated_qty;
        $.ajax({
          url: "/cart/update.js",
          data: {
            'updates': current_item
          },
          method: "POST",
          dataType: "JSON",
          success: function (data) {
            updateCart();
            if ($('#js-vat-show').hasClass('active')) {
              
              $('.bss-b2b-cart-item-no-vat-price').hide();
              $('.bss-b2b-cart-item-with-vat-price').css('display', 'block');
              $('.bss-b2b-cart-no-vat-price').hide();
              $('.bss-b2b-cart-with-vat-price').show();
              
            } else {
              $('.bss-b2b-cart-item-no-vat-price').show();
              $('.bss-b2b-cart-item-with-vat-price').css('display', 'none');
              $('.bss-b2b-cart-no-vat-price').show();
              $('.bss-b2b-cart-with-vat-price').hide();
              
              replaceVatTaxText();
          }
             
          },
          error: function (error) {
            console.log(error)
          }
        });
      });
      // $('.js_qtyminus').unbind("click");
      // $('.js_qtyminus').on('click', function (e) {
      $(document).on('click', '.js_qtyminus', function (e) {
        e.preventDefault();
        let parent = $(e.target).parents('.js_par_qty').eq(0);
        let current_qty = $(parent).attr('data-quantity');
        let updated_qty = parseInt(current_qty) - 1;
        $(this).parent().find("input.quantity__input").val(updated_qty);
        let current_item = {};
        let key = $(parent).attr('data-key');
        current_item[key] = updated_qty;
        $.ajax({
          url: "/cart/update.js",
          data: {
            'updates': current_item
          },
          method: "POST",
          dataType: "JSON",
          success: function (data) {
            updateCart();
            if ($('#js-vat-show').hasClass('active')) {
              $('.bss-b2b-cart-item-no-vat-price').hide();
              $('.bss-b2b-cart-item-with-vat-price').show();
              $('.bss-b2b-cart-no-vat-price').hide();
              $('.bss-b2b-cart-with-vat-price').show();
              console.log('has vat');
            } else {
              $('.bss-b2b-cart-item-no-vat-price').show();
              $('.bss-b2b-cart-item-with-vat-price').hide();
              $('.bss-b2b-cart-no-vat-price').show();
              $('.bss-b2b-cart-with-vat-price').hide();
              console.log('no vat')
          }
          },
          error: function (error) {
            console.log(error)
          }
        });
      });
      // $('.js-product-quantity-remove').unbind("click");
      // $('.js-product-quantity-remove').on('click', function (e) {
      $(document).on('click', '.js-product-quantity-remove', function (e) {
        e.preventDefault();
        let current_em = $(e.target);
        let key = $(this).attr('data-key');
        let updated_qty = 0;
        let current_item = {};
        current_item[key] = updated_qty;
        $.ajax({
          url: "/cart/update.js",
          data: {
            'updates': current_item
          },
          method: "POST",
          dataType: "JSON",
          success: function (data) {
            updateCart();
            if ($('#js-vat-show').hasClass('active')) {
              $('.bss-b2b-cart-item-no-vat-price').hide();
              $('.bss-b2b-cart-item-with-vat-price').show();
              $('.bss-b2b-cart-no-vat-price').hide();
              $('.bss-b2b-cart-with-vat-price').show();
            } else {
              $('.bss-b2b-cart-item-no-vat-price').show();
              $('.bss-b2b-cart-item-with-vat-price').hide();
              $('.bss-b2b-cart-no-vat-price').show();
              $('.bss-b2b-cart-with-vat-price').hide();
          }
          },
          error: function (error) {
            console.log(error)
          }
        });
      });

      // $.getJSON('/cart.js', function (cart) {

      //   let priceWrapper = $(".cart-item__price-wrapper");
      //   $.each(cart.items, function (index, item) {
      //     let itemLinePrice = `<span class="item_lineprice" style="text-decoration: none;">
      //       <span class="dp_detail" style="display: block;">
      //         <span class=" ">
      //           <span class="secondPriceValue">`+ Shopify.formatMoney(item.original_line_price, $('body').attr('data-money-format')) + `</span> 
      //           <span class="secondPriceLabel" style="color:red">Tax excl.</span>
      //         </span>
               
      //       </span>  
      //     </span>
      //     `;
      //     $(priceWrapper[index]).html(itemLinePrice);

      //   });
      // });
    }

  });
 
if ($('#js-vat-show').hasClass('active')) {
              
              $('.bss-b2b-cart-item-no-vat-price').hide();
              $('.bss-b2b-cart-item-with-vat-price').css('display', 'block');
              $('.bss-b2b-cart-no-vat-price').hide();
              $('.bss-b2b-cart-with-vat-price').show();
              
            } else {
              $('.bss-b2b-cart-item-no-vat-price').show();
              $('.bss-b2b-cart-item-with-vat-price').css('display', 'none');
              $('.bss-b2b-cart-no-vat-price').show();
              $('.bss-b2b-cart-with-vat-price').hide();
              
              replaceVatTaxText();
          }

}
$(document).on('click', '.boost-sd__button', function (e) {
//$(document).on('click', 'button:contains("Add to basket")', function (e) {
    
 e.preventDefault();
  let btnName = $(this).text();
  console.log(btnName)
  if(btnName == 'adding...'){
    setTimeout(function() {
    updateCart();
   // $('.drawer').addClass('active');
   $('#new-cart-icon-bubble').trigger('click');
      }, 2000);
  }else{
    
  }
 }); 

 $(document).on('click', 'button:contains("Select options")', function (e) {
 e.preventDefault();
   
  console.log("select option button")
  });   
// setTimeout(function() {
  
//  $(document).on('click', '.boost-sd__button', function (e) {
//     e.preventDefault();
//     updateCart();
//    // $('.drawer').addClass('active');
//    $('#new-cart-icon-bubble').trigger('click');
//   });
  
//     }, 300);


// function updateCart()
// {
//   $.ajax({
//     url: '/cart?view=cw-slide-cart',
//     dataType: 'HTML',
//     method: "GET",
//     success: function (htmlData) 
//     {
//       let html_markup = $(htmlData);
//       let to_replace = $(htmlData).find('.drawer__inner').html();
//       $('.drawer__inner').html(to_replace);
//       $('.drawer').addClass('active');
//       $('.drawer').removeClass('is-empty');

//       $.getJSON('/cart.js', function (cart) {
//         if (cart.item_count > 1) {
//           $("#cart-item-counts").html(cart.item_count + ' Items');
//         } else {
//           $("#cart-item-counts").html(cart.item_count + ' Item');
//         }
//       });



//     }
//   });
// }
$(document).ready(function () {

  if ($('.hero-slider').length > 0) {
    $('.hero-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: true,
      prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
      nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
    });
  }
  if ($('.service-slider').length > 0) {
    $('.service-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
      nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick"
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          }
        }
      ]

    });
  }
  if ($('.product-slider').length > 0) {
    $('.product-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
      nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 1270,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: "unslick"
        }
      ]

    });
  }
  if ($('.filter-list').length > 0) {
    $(".filter-list .item h4").click(function () {
      $(this).closest(".item").toggleClass("active");
    });
  }

  if ($('.featured-brand-slide').length > 0) {
    $('.featured-brand-slide').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
      nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 767,
          settings: "unslick"
        }

      ]

    });
  }
  if ($('.news-list').length > 0) {
    $('.news-list').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
      nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }

  if ($('.collection-sidebar').length > 0) {
    $(".collection-sidebar .btn-show-more a").click(function () {
      $(this).parents(".item").toggleClass("show");
    });
  }
  if ($('.tab-faq').length > 0) {
    $('.tab-faq li a').on('click', function (e) {
      var target = $(this).attr('data-rel');
      $('.tab-faq li a').removeClass('active');
      $(this).addClass('active');
      $("#" + target).fadeIn('slow').siblings(".tab-box").hide();
      return false;
    });
  }
  if ($('.faq-accordian').length > 0) {
    $('.faq-accordian .item .faq-question').click(function (e) {
      $(this).closest(".item").toggleClass(' active ');
      $(this).closest(".item").siblings().removeClass(' active ');
      $('.faq-answer').stop().hide();
      $('.active .faq-answer').stop().show();
      return false;
    });
  }
  if ($('.tab-media').length > 0) {
    $('.tab-media li a').on('click', function (e) {
      var target = $(this).attr('data-rel');
      $('.tab-media li a').removeClass('active');
      $(this).addClass('active');
      $("#" + target).fadeIn('slow').siblings(".tab-box").hide();
      return false;
    });
  }
  if ($('.slider-for').length > 0) {
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      infinite: false,
      prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
      nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
      asNavFor: '.slider-nav',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: false,
            fade: false,
          }
        }
      ]
    });
  }
  if ($('.slider-nav').length > 0) {
    $('.slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      verticalSwiping: true,
      dots: false,
      arrows: true,
      infinite: false,
      asNavFor: '.slider-for',
      prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
      nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            vertical: false,
            verticalSwiping: false,
            arrows: false,
          }
        }
      ]
    });
  }

  $('[data-fancybox]').fancybox({});

  const minus = $('.qty-minus');
  const plus = $('.qty-plus');
  const input = $('.qty-input');
  let test = $('#quantity');
  if ($('.pdp-quantity').length > 0) {
    minus.click(function (e) {
      e.preventDefault();
      var value = input.val();
      if (value > 1) {
        value--;
      }
      input.val(value);
      test.val(value);
    });

    plus.click(function (e) {
      e.preventDefault();
      var value = input.val();
      value++;
      input.val(value);
      test.val(value);
    })
  }

});


$(window).on("load", function () {
  setTimeout(function () {
    // if ($('.recommendationsSlider').length > 0) {      
    //   $('.recommendationsSlider').slick({
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     dots: false,
    //     arrows: true,
    //     infinite: true,
    //     prevArrow: '<button type="button" class="prev-arrow"><span class="fontello-icon-left-open"></span></button>',
    //     nextArrow: '<button type="button" class="next-arrow"><span class="fontello-icon-right-open"></span></button>',
    //     responsive: [
    //       {
    //         breakpoint: 1270,
    //         settings: {
    //           slidesToShow: 4,
    //         }
    //       },
    //       {
    //         breakpoint: 992,
    //         settings: {
    //           slidesToShow: 3,
    //         }
    //       },
    //       {
    //         breakpoint: 767,
    //         settings: {
    //           slidesToShow: 2,
    //         }
    //       },
    //       {
    //         breakpoint: 575,
    //         settings: {
    //           slidesToShow: 1,
    //         }
    //       }
    //     ]

    //   });
    // }
  }, 500);



});

// $(document).ready(function () {
  


//   $(document).on("click", "#js-vat-show", function () {
//     alert(123);
//     $(this).addClass('active');
//     $('#js-vat-hide').removeClass('active');
//     $('.bss-b2b-product-vat-price-has-vat').show();
//     $('.bss-b2b-product-vat-price-no-vat').hide();
//     $('.bss-b2b-cart-item-no-vat-price').hide();
//     $('.bss-b2b-cart-item-with-vat-price').show(); 
//     $('.bss-b2b-cart-no-vat-price').hide();
//     $('.bss-b2b-cart-with-vat-price').show(); 
//     $('.bss-b2b-cart-item-no-vat-price').hide();
//     $('.bss-b2b-cart-item-with-vat-price').show(); 
//     $('.bss-b2b-cart-item-no-vat-price')
//     replaceVatTaxText()
//   });
//   $(document).on("click", "#js-vat-hide", function () {
//     alert(112);
//     $(this).addClass('active');
//     $('.dpCompareAtPrice br').remove();
//     $('#js-vat-show').removeClass('active');
//     $('.dualPrice.dp_detail br').remove();
//     $('.firstPrice').hide();
//     $('.secondPrice').show();
//     $('.bss-b2b-product-vat-price-has-vat').hide();
//     $('.bss-b2b-product-vat-price-no-vat').show();
//     $('.bss-b2b-cart-item-no-vat-price').show();
//     $('.bss-b2b-cart-item-with-vat-price').hide(); 
//     $('.bss-b2b-cart-no-vat-price').show();
//     $('.bss-b2b-cart-with-vat-price').hide();
//     $('.bss-b2b-cart-item-no-vat-price').show();
//     $('.bss-b2b-cart-item-with-vat-price').hide(); 
//     replaceVatTaxText()
//   });
// });


// function get_variant() {
//   var final_val = "";
//   var didFind = false;
//   let didFindTheVariant = false;
//   if ($('.js_size_drop').length > 0) {
//     const size_val = $('.js_size_drop option:selected').val();
//     final_val = size_val;
//   }

//   if ($('.js_product_radio').length > 0) {
//     const color = $('.js_product_radio:checked').val();
//     if (final_val != '') {
//       final_val = final_val + ' / ' + color;
//     } else {
//       final_val = color;
//     }

//   }

//   if ($('.js_other_drop').length > 0) {
//     const size_val = $('.js_other_drop option:selected').val();
//     if (final_val != '') {
//       final_val = final_val + ' / ' + size_val;

//     } else {
//       final_val = size_val;
//     }
//   }


//   $('.actual-variants').find('option').each(function (ix, em) {
//     var get_val = $(em).attr('data-variant-select');

//     if (get_val == final_val) {
//       $(".actual-variants option").prop('selected', false);
//       didFindTheVariant = true;
//       //$(".actual-variants option").removeAttr("selected");
//       $(this).prop('selected', true);
//       $(".actual-variants").trigger("change");
//       let price = $('.actual-variants option:selected').attr('data-price');
//       let wasprice = $('.actual-variants option:selected').attr('data-compareat-price');
//       //$(".js_was_price").html(wasprice);
//       let BarCode = $('.actual-variants option:selected').attr('data-barcode');


//       didFind = true;
//       //$(".js_now_price").html(price);

//       $(".product-code span").text(BarCode);
//       if(BarCode == ''){
//         $(".product-code").hide();
//       }else{
//         $(".product-code").show()
//       }
//       var imagePath = $(".actual-variants option:selected").attr('data-image');
//       var slick_num = $(".actual-variants option:selected").attr('data-slick-index');
//       $('.imgbig').each(function () {
//         var image_index = $(this).attr('data-slick-index');
//         var slick_image = $(this).find('img').attr('data-pro-img');
//         if (slick_image == imagePath) {
//           $('.probig').slick('slickGoTo', parseInt(image_index));
//         }
//       });
//       //return false;
//     }
//   });



//   if ($(".actual-variants option:selected").attr('data-available') == "true") {
//     $('.product-page-atc').removeClass('js_disabled');
//     $('.product-page-atc').html("Add to basket <span><img src='//nixonsafety.co.uk/cdn/shop/files/shopping-bag.svg?v=12364563725240358140' /></span>");
//     $('.product-page-atc').css('pointer-events', 'all');
//     $('.product-page-atc').css('opacity', '1');
//     $('.js_in_stock').show();
//     $('.js_out_stock').hide();
//     $('.progress_desktop').css('display', 'flex');
//   } 
//   else {
//     $('.product-page-atc').addClass('js_disabled');
//     $('.product-page-atc').html("Sold Out");
//     $('.product-page-atc').css('pointer-events', 'none');
//     $('.product-page-atc').css('opacity', '0.5');
//     $('.js_out_stock').show();
//     $('.js_in_stock').hide();
//     $('.js_out_stock b').css('color', 'red');
//     $('.progress_desktop').css('display', 'none');
//     return false;
//   }
//   if (didFindTheVariant == false) {
//     $(".product-page-atc").html("Not Available");
//     $(".product-page-atc").css("opacity", "0.5");
//     $(".product-page-atc").css("pointer-events", "none");
//   } else {
//     $(".product-page-atc").html("Add to basket <span><img src='//nixonsafety.co.uk/cdn/shop/files/shopping-bag.svg?v=12364563725240358140' /></span>");
//     $(".product-page-atc").css("opacity", "1");
//     $(".product-page-atc").css("pointer-events", "all");
//   }
// }

// $(document).on('change', '.js_size_drop', function () {
//   get_variant();
// });

// $(document).on('change', '.js_product_radio', function () {
//   get_variant();
// });
// $(document).on('change', '.js_other_drop', function () {
//   get_variant();
// });

$(document).on('change', `.js-cw-product-page-form [data-option-1], .js-cw-product-page-form [data-option-2], .js-cw-product-page-form [data-option-3]`, function (e) {
  let option1 = option2 = option3 = null;
  let checkEleType = $(this).attr('data-checked');
  let opt1 = $('.js-cw-product-page-form [data-option-1]').attr('data-checked');
  let opt2 = $('.js-cw-product-page-form [data-option-2]').attr('data-checked');
  let opt3 = $('.js-cw-product-page-form [data-option-3]').attr('data-checked');

  var final_val = "";
  var didFind = false;
  let didFindTheVariant = false;

  if (opt1 == 'radio') {
    option1 = $(`.js-cw-product-page-form [data-option-1] input:checked`).val();
  } else {
    option1 = $(`.js-cw-product-page-form [data-option-1] option:selected`).val();
  }
  if (opt2 == 'radio') {
    option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();
  } else {
    option2 = $(`.js-cw-product-page-form [data-option-2] option:selected`).val();
  }
  if (opt3 == 'radio') {
    option3 = $(`.js-cw-product-page-form [data-option-3] input:checked`).val();
  } else {
    option3 = $(`.js-cw-product-page-form [data-option-3] option:selected`).val();
  }

  let variant_id = null;
  let current_selected_option = null;
  if (option2 == null & option3 == null) {

    // option1 = $(`.js-cw-product-page-form [data-option-1] option:selected`).val();
    // option2 = $(`.js-cw-product-page-form [data-option-2] input:checked`).val();

    final_val = option1;
  }


  if (option2 != null & option3 == null) {
    final_val = option1 + ' / ' + option2;
  }
  if (option2 != null & option3 != null) {
    final_val = option1 + ' / ' + option2 + ' / ' + option3;
  }


  $('.actual-variants').find('option').each(function (ix, em) {
    var get_val = $(em).attr('data-variant-select');

    if (get_val == final_val) {

      $(".actual-variants option").prop('selected', false);
      didFindTheVariant = true;
      //$(".actual-variants option").removeAttr("selected");
      $(this).prop('selected', true);
      $(".actual-variants").trigger("change");
      let price = $('.actual-variants option:selected').attr('data-price');
      let wasprice = $('.actual-variants option:selected').attr('data-compareat-price');
      //$(".js_was_price").html(wasprice);
      let BarCode = $('.actual-variants option:selected').attr('data-barcode');


      didFind = true;
      //$(".js_now_price").html(price);

      $(".product-code span").text(BarCode);
      if (BarCode == '') {
        $(".product-code").hide();
      } else {
        $(".product-code").show()
      }
      var imagePath = $(".actual-variants option:selected").attr('data-image');
      var slick_num = $(".actual-variants option:selected").attr('data-slick-index');
      $('.imgbig').each(function () {
        var image_index = $(this).attr('data-slick-index');
        var slick_image = $(this).find('img').attr('data-pro-img');
        if (slick_image == imagePath) {
          $('.probig').slick('slickGoTo', parseInt(image_index));
        }
      });
      //return false;
    }
  });



  if ($(".actual-variants option:selected").attr('data-available') == "true") {
    $('.product-page-atc').removeClass('js_disabled');
    $('.product-page-atc').html("Add to basket <span><img src='//nixonsafety.co.uk/cdn/shop/files/shopping-bag.svg?v=12364563725240358140' /></span>");
    $('.product-page-atc').css('pointer-events', 'all');
    $('.product-page-atc').css('opacity', '1');
    $('.js_in_stock').show();
    $('.js_out_stock').hide();
    $('.progress_desktop').css('display', 'flex');
  } else {
    $('.product-page-atc').addClass('js_disabled');
    $('.product-page-atc').html("Sold Out");
    $('.product-page-atc').css('pointer-events', 'none');
    $('.product-page-atc').css('opacity', '0.5');
    $('.js_out_stock').show();
    $('.js_in_stock').hide();
    $('.js_out_stock b').css('color', 'red');
    $('.progress_desktop').css('display', 'none');
    return false;
  }
  if (didFindTheVariant == false) {
    $(".product-page-atc").html("Not Available");
    $(".product-page-atc").css("opacity", "0.5");
    $(".product-page-atc").css("pointer-events", "none");
  } else {
    $(".product-page-atc").html("Add to basket <span><img src='//nixonsafety.co.uk/cdn/shop/files/shopping-bag.svg?v=12364563725240358140' /></span>");
    $(".product-page-atc").css("opacity", "1");
    $(".product-page-atc").css("pointer-events", "all");
  }

});

$(document).on('click', '.product-page-atc', function (e) {
  e.preventDefault();
  var currentElement = $(this);
  var variant_id = $('.actual-variants option:selected').val();
  var test = $("form.cw-product-page-form").serialize();
  var quantity = $('#js_pro_qty').val();
  var itemsArray = [];
  var customItem = { id: variant_id, quantity: quantity };
  itemsArray.push(customItem);
  let form = $(`form.js-cw-product-page-form`)[0];

  var formData = new FormData(form);
  console.log(...formData);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { items: itemsArray },
    success: function (success_data) {
      
         updateCart();
   
    
        if ($('#js-vat-show').hasClass('active')) {
          $('.bss-b2b-cart-item-no-vat-price').hide();
          $('.bss-b2b-cart-item-with-vat-price').show();
          $('.bss-b2b-cart-no-vat-price').hide();
          $('.bss-b2b-cart-with-vat-price').show();
          console.log('has vat');
        } else {
          $('.bss-b2b-cart-item-no-vat-price').show();
          $('.bss-b2b-cart-item-with-vat-price').hide();
          $('.bss-b2b-cart-no-vat-price').show();
          $('.bss-b2b-cart-with-vat-price').hide();
          console.log('no vat')
      }
      let selctedVarTitle = $('#product_dropdown option:selected').text();
      let addedQty = $('#js_pro_qty').val();
      let selectedVarPrice = $('#product_dropdown option:selected').attr('data-withoutmoney-price');
      let addedProTotalPrice = selectedVarPrice * addedQty;
      $('.selectedVal').text(selctedVarTitle);
      $('.addedQty').text(addedQty);
      $('.selectedVarPrice').text(Shopify.formatMoney(selectedVarPrice, $('body').attr('data-money-format')));
      $('.currentAddedPrototal').text(Shopify.formatMoney(addedProTotalPrice, $('body').attr('data-money-format')));
      $('.drawer').addClass('active');
    },
    error: function (data) {
      alert(data.responseJSON.description);
    }
  });

});



$(document).on('click', '.btn-view-basket', function (e) {
  e.preventDefault();
  var currentElement = $(this);
  var variant_id = $('.actual-variants option:selected').val();
  var test = $("form.cw-product-page-form").serialize();
  var quantity = $('#js_pro_qty').val();
  var itemsArray = [];
  var customItem = { id: variant_id, quantity: quantity };
  itemsArray.push(customItem);
  let form = $(`form.js-cw-product-page-form`)[0];

  var formData = new FormData(form);
  console.log(...formData);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { items: itemsArray },
    success: function (success_data) {
      updateCart();
      let selctedVarTitle = $('#product_dropdown option:selected').text();
      let addedQty = $('#js_pro_qty').val();
      let selectedVarPrice = $('#product_dropdown option:selected').attr('data-withoutmoney-price');
      let addedProTotalPrice = selectedVarPrice * addedQty;

      $('.selectedVal').text(selctedVarTitle);
      $('.addedQty').text(addedQty);
      $('.selectedVarPrice').text(Shopify.formatMoney(selectedVarPrice, $('body').attr('data-money-format')));
      $('.currentAddedPrototal').text(Shopify.formatMoney(addedProTotalPrice, $('body').attr('data-money-format')));
      $('.close').click();
      $('.drawer').addClass('active');
    },
    error: function (data) {
      alert(data.responseJSON.description);
    }
  });

});
$(document).on('change', '.qty-input', function () {

  let proQty = $(this).val();
  $('#quantity').val(proQty);
});
$(document).on('click', '.js_next_btn', function (e) {
  let selectedVarPrice = $('#product_dropdown option:selected').attr('data-withoutmoney-price');
  //$('.logo_price').text(Shopify.formatMoney(selectedVarPrice, $('body').attr('data-money-format')));
});
$(document).on('click', '.product-custom-popup', function (e) {
  e.preventDefault();
  let selctedVarTitle = $('#product_dropdown option:selected').text();
  let addedQty = $('#js_pro_qty').val();
  let selectedVarPrice = $('#product_dropdown option:selected').attr('data-withoutmoney-price');
  let addedProTotalPrice = selectedVarPrice * addedQty;

  $('.selectedVal').text(selctedVarTitle);
  $('.addedQty').text(addedQty);

  $('.selectedVarPrice').text(Shopify.formatMoney(selectedVarPrice, $('body').attr('data-money-format')));
  $('.currentAddedPrototal').text(Shopify.formatMoney(addedProTotalPrice, $('body').attr('data-money-format')));

});


$(document).on('click', '.product-custom-popup-default', function (e) {
  e.preventDefault();
  //let selctedVarTitle = $('#default_var').text();
  let addedQty = $('#js_pro_qty').val();
  let selectedProPrice = $('#default_var').attr('data-default-price');
  let addedProTotalPrice = selectedProPrice * addedQty;

  // $('.selectedVal').text(selctedVarTitle);
  $('.addedQty').text(addedQty);
  $('.selectedVarPrice').text(Shopify.formatMoney(selectedProPrice, $('body').attr('data-money-format')));
  $('.currentAddedPrototal').text(Shopify.formatMoney(addedProTotalPrice, $('body').attr('data-money-format')));

});

// $(document).ready(function () {
//   get_variant()
// });


$(document).on('click', '.upsell_atc', function (e) {
  e.preventDefault();

  var currentElement = $(this);
  var variant_id = $(this).attr('data-id');
  var quantity = 1;

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { id: variant_id, quantity: quantity },
    success: function (success_data) {
      setTimeout(function () { }, 2000);
      updateCart();
      $('.drawer').addClass('active');
    },
    error: function (data) {
      alert(data.responseJSON.description);
    }
  });

});
$(".product-page-atc").on("mouseover", function () {
  //stuff to do on mouseover
  $('.product-page-atc img').attr('src', 'https://cdn.shopify.com/s/files/1/0677/7205/5848/files/hover_cart_icon_7288dca3-cc9d-4cee-8cb5-5c78314ad9c7.svg?v=1676268214');
});
$(".product-page-atc").on("mouseout", function () {
  //stuff to do on mouseover
  $('.product-page-atc img').attr('src', 'https://cdn.shopify.com/s/files/1/0677/7205/5848/files/shopping-bag.svg?v=12364563725240358140');
});

var emailInput;
$(".email1").on("change", function () {
  emailInput = $(this).val();

});

// $("#final_submit").on("click", function (e) {
//   // e.preventDefault();
//   if (validateEmail(emailInput)) {
//     return true;
//   } else {
//     alert('Please enter valid email address!');
//     return false;
//   }

// });
$(document).on( "click", "#final_submit", function(e) {
  e.preventDefault();
  var password = $('#CreatePassword').val();
  
  var pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;
  var isValid = pattern.test(password);
  if(password == ''){
    alert("Please Enter Password!");
  }
  else if (!isValid) {
    alert("Password must contain at least one number, one uppercase letter, one lowercase letter, one special symbol and be 8 characters or longer.");
  }else if  ($('#CreatePassword').val() != $('#confirm-password').val()){
   alert('Passwords do not match.');
  } else {
    $('form#create_customer').eq(0).submit();
  }
});

$("#final_submit").on("click", function (e) {
 
  e.preventDefault();
  if (validateEmail(emailInput)) {
    return true;
  } else {
    alert('Please enter valid email address!');
    return false;
  }
  

});
function validateEmail(email1) {
  var pattern = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

  return $.trim(email1).match(pattern) ? true : false;
}

var createCustomerForm = document.getElementById("create_customer");
var passwordInput = document.getElementById("CreatePassword");
var passwordConfirmInput = document.getElementById("confirm-password");
$(function () {
  $('form#create_customer').submit(function (e) {
    if ($('#CreatePassword').val() != $('#confirm-password').val()) {
      e.preventDefault();
      alert('Passwords do not match.');
    }
  });
});

$(document).on('click', '#new-cart-icon-bubble', function (e) {
  $('.drawer').addClass('active');
   
   if ($('#js-vat-show').hasClass('active')) {
              $('.bss-b2b-cart-item-no-vat-price').hide();
              $('.bss-b2b-cart-item-with-vat-price').show();
              $('.bss-b2b-cart-no-vat-price').hide();
              $('.bss-b2b-cart-with-vat-price').show();
            } else {
              $('.bss-b2b-cart-item-no-vat-price').show();
              $('.bss-b2b-cart-item-with-vat-price').hide();
              $('.bss-b2b-cart-no-vat-price').show();
              $('.bss-b2b-cart-with-vat-price').hide();
          }
});
$(document).on('change', 'input[name="updates[]"]', function (e) {
  setTimeout(function () {
    $.getJSON('/cart.js', function (cart) {
      if (cart.item_count > 1) {
        $("#cart-item-counts").html(cart.item_count + ' Items');
      } else {
        $("#cart-item-counts").html(cart.item_count + ' Item');
      }
    });
  }, 500);
});


$(document).on('click', '.js-default-atc', function (e) {
  e.preventDefault();

  var currentElement = $(this);
  var variant_id = $('input[name="id"]').val();
  var quantity = $('#js_pro_qty').val();

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { id: variant_id, quantity: quantity },
    success: function (success_data) {
      setTimeout(function () { }, 2000);
      updateCart();
      $('.drawer').addClass('active');
    },
    error: function (data) {
      alert(data.responseJSON.description);
    }
  });

});
$(document).on('click', '[cart-remove-button]', function (e) {

});


$(document).ready(function () {

  $(document).on('click', '.home-product-atc', function (e) {
    e.preventDefault();

    var currentElement = $(this);
    var variant_id = $(this).attr('data-id');
    var quantity = 1;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { id: variant_id, quantity: quantity },
      success: function (success_data) {
        setTimeout(function () { }, 2000);
        updateCart();
        $('.drawer').addClass('active');
      },
      error: function (data) {
        alert(data.responseJSON.description);
      }
    });

  });




});

$(document).ready(function () {
  var randNum = Math.floor(Math.random() * 60) + 1;
  $('.js_qty_pro').text(randNum);
  $('.progress-done').attr('data-done', randNum);
  $('.progress-done').css('width', randNum + '%');

  var randNumWatching = Math.floor(Math.random() * 10) + 1;
  $('.js_random_watching').text(randNumWatching);
});


$(document).ready(function () {
  let js_total = $('.js_fre_total_price').text();
  if (js_total > 0) {
    $('.js_fbt_pro_atc').css('pointer-events', 'all');
  } else {
    $('.js_fbt_pro_atc').css('pointer-events', 'none');
  }

  $(document).on('click', '.custom-checkbox', function (e) {
    let totalPrice = 0;

    $('.js_fbt_pro_atc').css('pointer-events', 'all');

    $(`[type=checkbox]:checked`).each(function (ix, em) {
      let productPrice = $(em).data('price');
      totalPrice += parseInt(productPrice);
    });

    //$('.js_fre_total_price').text(totalPrice)
    $('.js_fre_total_price').html(Shopify.formatMoney(totalPrice, $('body').attr('data-money-format')));
    //$('.js_fre_total_price').text(totalPrice);
    //$('.js_total_feq_price').text(Shopify.formatMoney(totalPrice, theme.moneyFormat));
    if (totalPrice > 0) {
    } else {
      $('.js_fbt_pro_atc').css('pointer-events', 'none');
    }
  });
});


$(document).on('click', '.js_fbt_pro_atc', function (e) {
  e.preventDefault();


  let itemsArray = [];
  // let itemProperties = [];
  // var current_time = Date.now();
  $('[type=checkbox]:checked').each(function (ix, em) {
    $(this).prop('checked', true);


    let currentElement = $(this);
    let vid = $(currentElement).attr('data-pro-id');
    let qty = 1;

    let singleItem = {
      id: vid,
      quantity: qty


    };
    itemsArray.push(singleItem);
  });


  $.ajax({
    url: "/cart/add.js",
    data: { items: itemsArray },
    method: "POST",
    dataType: "JSON",
    success: function (success_data) {
      setTimeout(function () { }, 2000);
      updateCart();
      $('.drawer').addClass('active');

    },
    error: function (data) {
      window.alert(data.responseJSON.description);
    }
  });

});
function countdown(elementName, minutes, seconds) {
  var element, endTime, hours, mins, msLeft, time;

  function twoDigits(n) {
    return (n <= 9 ? "0" + n : n);
  }

  function updateTimer() {
    msLeft = endTime - (+new Date);
    if (msLeft < 1000) {
      element.innerHTML = "Time is up!";
    } else {
      time = new Date(msLeft);
      hours = time.getUTCHours();
      mins = time.getUTCMinutes();
      element.innerHTML = (hours ? hours + ':' + twoDigits(mins) : mins) + ':' + twoDigits(time.getUTCSeconds());
      setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
    }
  }

  element = document.getElementById(elementName);
  endTime = (+new Date) + 1000 * (60 * minutes + seconds) + 500;
  updateTimer();
}

$(document).ready(function () {

  countdown("ten-countdown", 15, 0);

});
var current_item = {}
$(document).on('click', '.js-remove-bundle', function (e) {
  e.preventDefault();

  let class_name = $(this).attr('data-class');
  //console.log('class_name',class_name);
  $('.' + class_name).each(function () {
    var key = $(this).attr('data-key');
    var qty = 0;
    current_item[key] = qty;
  });

  //console.log(current_item);

  $.ajax({
    url: "/cart/update.js",
    data: { 'updates': current_item },
    method: "POST",
    dataType: "JSON",
    success: function (data) {
      window.location = "/cart"
    }, error: function (error) {
      console.log(error)
    }
  });
})

$('.js-product-quantity-remove').on('click', function (e) {
  e.preventDefault();
  let current_em = $(e.target);
  let key = $(this).attr('data-key');
  let updated_qty = 0;
  let current_item = {};
  current_item[key] = updated_qty;
  $.ajax({
    url: "/cart/update.js",
    data: {
      'updates': current_item
    },
    method: "POST",
    dataType: "JSON",
    success: function (data) {
      updateCart();
    },
    error: function (error) {
      console.log(error)
    }
  });
});


$(document).on('click', '.drawer__close', function (e) {
  e.preventDefault();
  $('.drawer').removeClass('active');
  $('body').removeClass('is-active-sidecart');
  

  setTimeout(function () {
    $('.dualPrice.dp_detail br').remove();
  }, 2000);

});
$(document).on('click', '#new-cart-icon-bubble', function (e) {
  updateCart();
  if ($('#js-vat-show').hasClass('active')) {
    $('.bss-b2b-cart-item-no-vat-price').hide();
    $('.bss-b2b-cart-item-with-vat-price').show();
    $('.bss-b2b-cart-no-vat-price').hide();
    $('.bss-b2b-cart-with-vat-price').show();
  } else {
    $('.bss-b2b-cart-item-no-vat-price').show();
    $('.bss-b2b-cart-item-with-vat-price').hide();
    $('.bss-b2b-cart-no-vat-price').show();
    $('.bss-b2b-cart-with-vat-price').hide();
}
});

// if($('.byob-footer').length > 0 ){
//   $('#new-cart-icon-bubble').trigger('click')
// }

$(document).ready(function () {
  updateCart();
  $('.dualPrice.dp_detail br').remove();

});


$('input[type="checkbox"]').change(function () {

  var total_checked = $("input[type='checkbox']:checked").length;
  $(".js_logo_posi_count").html(total_checked);
  let selectedVarPrice = total_checked * 8 * 100;

  $('.logo_price').text(Shopify.formatMoney(selectedVarPrice, $('body').attr('data-money-format')));

});

$('.js_application_method:checked').length;

$(document).on('click', '.js_application_method', function (e) {
  let applicationMethod = $(this).val();

  $('.js_select_method').text(applicationMethod + ' ');

});

$(document).on('click', '.SubmitNewCustomisation-button-EWk', function (e) {
  //let applicationMethod = $(this).val();
  $('.js_next_btn').trigger('click');

});

$(document).on('click', '.js_custom_type_wrap', function (e) {
  let applicationMethod = $(this).val();
  // alert(applicationMethod)
  $('.js_custom_type').text(applicationMethod + ' ');
});

function readURL(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $('#blah').attr('src', e.target.result);
    }

    reader.readAsDataURL(input.files[0]);
  }
}

$("#imgInp").change(function () {
  readURL(this);

});
$(document).on('click', '.image_remove', function (e) {
  $("#imgInp").val('');
  $('#blah').attr('src', '');
  $(this).hide();
});
$("#imgInp").change(function () {

  let imageVal = $(this).val();
  if (imageVal != '') {
    $('.image_remove').show();
  } else {
    $('.image_remove').hide();
  }
});
$(document).on('keypress', '#first_line', function (e) {
  var fontText = $(this).val();

  $('#font-change').text(fontText);
});
function base64UrlToBlob(base64Url) {
  const base64 = base64Url.substr(base64Url.indexOf(',') + 1);
  const byteString = atob(base64);
  const byteStringLength = byteString.length;
  const byteArray = new Uint8Array(byteStringLength);
  for (let i = 0; i < byteStringLength; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([byteArray], {
    type: 'image/png'
  });
}

let b64toBlob = (b64Data, contentType, sliceSize) => {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
}

var colorPicker = document.getElementById('js_color_change');
var fontPicker = document.getElementById('custom_fontchange');
const canvas = document.getElementById("textCanvas");
const ctx = canvas.getContext("2d");
imageElem = document.getElementById('js_canvas_image');
const input1 = document.getElementById("first_line");
const input2 = document.getElementById("second_line");
const input3 = document.getElementById("third_line");

// Listen for input changes on both text fields
input1.addEventListener("input", drawUserInput);
input2.addEventListener("input", drawUserInput);
input3.addEventListener("input", drawUserInput);

function drawUserInput() {

  var color = colorPicker.value;
  var font = fontPicker.value;
  // Clear the canvas
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  // Draw the input from the first text field

  ctx.font = '25px' + ' ' + font;
  ctx.fillStyle = color;
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  // ctx.fillText(input1.value, 50, 50);
  // ctx.fillText(input2.value, 50, 80);
  // ctx.fillText(input3.value, 50, 110);
  ctx.fillText(input1.value, canvas.width / 2, canvas.height / 2 - 30);
  ctx.fillText(input2.value, canvas.width / 2, canvas.height / 2);
  ctx.fillText(input3.value, canvas.width / 2, canvas.height / 2 + 30);
  imageElem.src = ctx.canvas.toDataURL();
}


function colorChange() { }
// var colorPicker = document.getElementById('js_color_test');
// var fontPicker = document.getElementById('custom_fontchange');
colorPicker.addEventListener('change', function () {
  colorPicker.setAttribute("name", "properties[color]");
  var color = colorPicker.value;
  var font = fontPicker.value;
  var textBox1Val = document.getElementById("first_line").value;
  var textBox2Val = document.getElementById("second_line").value;
  var textBox3Val = document.getElementById("third_line").value;
  if(color == 'white'){
    $('#js_canvas_image').css('background', '#000');
  }else{
    $('#js_canvas_image').css('background', '#fff');
  }
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = color;
  ctx.font = '25px' + ' ' + font;
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  ctx.fillText(input1.value, canvas.width / 2, canvas.height / 2 - 30);
  ctx.fillText(input2.value, canvas.width / 2, canvas.height / 2);
  ctx.fillText(input3.value, canvas.width / 2, canvas.height / 2 + 30);
  imageElem.src = ctx.canvas.toDataURL();

});


// let fontPicker1 = document.getElementById('custom_fontchange');


fontPicker.addEventListener('change', function () {
  fontPicker.setAttribute("name", "properties[font]");
  var colorPicker = document.getElementById('js_color_change');
  var font = fontPicker.value;
  var color = colorPicker.value;
  var textBox1Val = document.getElementById("first_line").value;
  var textBox2Val = document.getElementById("second_line").value;
  var textBox3Val = document.getElementById("third_line").value;
  ctx.clearRect(0, 0, canvas.width, canvas.height);    //tCtx.fillText(x, 0, 10);
  ctx.fillStyle = color;
  ctx.font = '25px' + ' ' + font;
  // console.log(tCtx.font = '25px' + ' ' + font);
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  ctx.fillText(input1.value, canvas.width / 2, canvas.height / 2 - 30);
  ctx.fillText(input2.value, canvas.width / 2, canvas.height / 2);
  ctx.fillText(input3.value, canvas.width / 2, canvas.height / 2 + 30);
  imageElem.src = ctx.canvas.toDataURL();
});


$(document).on('click', 'button:contains("submit")', function (e) {
  //$("button:contains('submit')").click(function(e) {
  e.preventDefault();
  let form = $(`form.js-cw-product-page-form-test`)[0];
  let formData = new FormData(form);
  console.log(...formData);

  let uploadedImageString = $(`#js_canvas_image`).attr('src');

  if (uploadedImageString != undefined && uploadedImageString != '') {
    let uploadedImageParts = uploadedImageString.split(";");
    let uploadedImageContentType = uploadedImageParts[0].split(":")[1];
    let uploadedImageRD = uploadedImageParts[1].split(",")[1];
    let uploadedImageBlob = b64toBlob(uploadedImageRD, uploadedImageContentType);
    formData.append(`[properties[Uploaded Image]]`, uploadedImageBlob, 'uploadedImage.jpeg');
    console.log('formdata', ...formData);
    console.log('upload blob img', uploadedImageBlob);
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    processData: false,
    contentType: false,
    success: function (response) {
      // $('#sumit-check').attr('value','checked')
      // Redirect to the cart page
      // window.location.href = '/cart';
       
      updateCart();
      $('.close').click();
      $('.drawer').addClass('active');
      $('body').addClass('is-active-sidecart');
      // let pageURL = window.location.href + "?reopenStep"
      // console.log(pageURL)
      // window.location = pageURL
      // $('.js-cw-product-page-form-test').submit();
      $("#myModalFooter").empty();
      prep_modal();
      $('#myModal').find('.CustomCheckbox-inputHidden-Rt5:checked').prop('checked', false);
      $('#myModal').find('#imgInp').val('');
      $('#myModal').find('#blah').attr('src', '');
      $('#myModal').find('.image_remove').hide();
      $('#myModal').find('#first_line').val('');
      $('#myModal').find('#second_line').val('');
      $('#myModal').find('#third_line').val('');
      $('#myModal').find('#js_canvas_image').attr('src', '');
      $('#js_color_change option').prop('selected', function () {
        return this.defaultSelected;
      });
      $('#custom_fontchange option').prop('selected', function () {
        return this.defaultSelected;
      });

    },
    error: function (xhr, status, error) {
      // Handle the error
      console.log(error);
    }
  });
});







// var tCtx = document.getElementById('textCanvas').getContext('2d'), //Hidden canvas
// imageElem = document.getElementById('custom_text'); //Image element
// // Text input element
// document.getElementById('js_canvas_text').addEventListener('keyup', function() {
//  //me(color)
// tCtx.canvas.width = tCtx.measureText(this.value).width;
// // const colorPicker = document.getElementById('font_color');
// // colorPicker.addEventListener('change', function() {
// //   const color = colorPicker.value;

// // });
// tCtx.fillStyle = 'red';
// imageElem.src = tCtx.canvas.toDataURL();
// tCtx.fillText(this.value, 0, 10);
// console.log(imageElem.src);
// }, false);


$(document).ready(function () {
  $('.CustomRadio-input-2HZ').on('change', function () {

    if ($('#logo').is(':checked')) {
      $('.uploadcustomlogo').show();
      $('.customprint').hide();
    }
    else {
      $('.customprint').show();
      $('.uploadcustomlogo').hide();
    }
  });
  if ($('#logo').is(':checked')) {
    $('.uploadcustomlogo').show();
    $('.customprint').hide();
  }
  else {
    $('.customprint').show();
    $('.uploadcustomlogo').hide();
  }
  $('.cus-radio-hide-show .cus-field').on('change', function () {
    if ($('#configureYourLogo').is(':checked')) {
      $('.file-upload-content').addClass('show');
    }
    else {
      $('.file-upload-content').removeClass('show');
    }
  });
});


// if($('img#blah').attr('src') == '') {
//   $('img#blah').hide();
// }
// $('.imgInp').on('click', function() {
//     $('img#blah').show();
// });


// $(document).ready(function() {
//   $('input[type=checkbox]').change(function() {
//     alert(123);
//     if(this.checked) {
//       // Checkbox is checked, update variant options
//       $('.js_other_drop').empty();
//       $('.js_other_drop').append($('<option>', {value: '4', text: 'Option 4'}));
//       $('.js_other_drop').append($('<option>', {value: '5', text: 'Option 5'}));
//       $('.js_other_drop').append($('<option>', {value: '6', text: 'Option 6'}));
//     } else {
//       // Checkbox is not checked, restore original variant options
//       $('#variant-select').empty();
//       $('#variant-select').append($('<option>', {value: '1', text: 'Option 1'}));
//       $('#variant-select').append($('<option>', {value: '2', text: 'Option 2'}));
//       $('#variant-select').append($('<option>', {value: '3', text: 'Option 3'}));
//     }
//   });
// });

$(document).ready(function () {

  $('input[type=checkbox]').change(function () {
    var total_checked = $("input[type='checkbox']:checked").length;
    if (total_checked == 1) {
      $(".selectPrintVal").text(total_checked + ' ' + 'Print');
    } else {
      $(".selectPrintVal").text(total_checked + ' ' + 'Prints');
    }
    $('.selected_position_text').html(total_checked + ' ' + 'selected');
    let text = $('.selectPrintVal').text();
    
    $(".js_other_drop option").filter(function () {
      //may want to use $.trim in here
      return $(this).text() == text;
    }).prop('selected', true);
    $(".js_other_drop").trigger('change');
});

  

setTimeout(function() {
    $('#js-vat-hide').click();
}, 5000);
  
});
